import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "identifying-info" }
const _hoisted_2 = {
  key: 0,
  class: "labels-and-annotations-empty"
}
const _hoisted_3 = {
  key: 1,
  class: "labels"
}
const _hoisted_4 = {
  key: 2,
  class: "annotations"
}

import IdentifyingInformation, { Row as IdentifyingInformationRow } from '@shell/components/Resource/Detail/Metadata/IdentifyingInformation/index.vue';
import Labels, { Label } from '@shell/components/Resource/Detail/Metadata/Labels/index.vue';
import Annotations, { Annotation } from '@shell/components/Resource/Detail/Metadata/Annotations/index.vue';
import SpacedRow from '@shell/components/Resource/Detail/SpacedRow.vue';
import KeyValue from '@shell/components/Resource/Detail/Metadata/KeyValue.vue';
import { computed } from 'vue';
import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';
import { ExtensionPoint, PanelLocation } from '@shell/core/types';
import ExtensionPanel from '@shell/components/ExtensionPanel.vue';

export interface MetadataProps {
  resource: any;
  identifyingInformation: IdentifyingInformationRow[],
  labels: Label[],
  annotations: Annotation[],
  onShowConfiguration?: (returnFocusSelector: string) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    resource: {},
    identifyingInformation: {},
    labels: {},
    annotations: {},
    onShowConfiguration: { type: Function }
  },
  emits: ['show-configuration'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const store = useStore();
const i18n = useI18n(store);

const showBothEmpty = computed(() => __props.labels.length === 0 && __props.annotations.length === 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SpacedRow, _mergeProps({ class: "metadata" }, _ctx.$attrs), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(IdentifyingInformation, { rows: _ctx.identifyingInformation }, null, 8, ["rows"])
        ]),
        _cache[3] || (_cache[3] = _createTextVNode()),
        (showBothEmpty.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(KeyValue, {
                type: "active",
                rows: [],
                propertyName: _unref(i18n).t('component.resource.detail.metadata.labelsAndAnnotations'),
                onShowConfiguration: _cache[0] || (_cache[0] = (returnFocusSelector, defaultTab) => emit('show-configuration', returnFocusSelector, defaultTab))
              }, null, 8, ["propertyName"])
            ]))
          : _createCommentVNode("", true),
        _cache[4] || (_cache[4] = _createTextVNode()),
        (!showBothEmpty.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(Labels, {
                labels: _ctx.labels,
                onShowConfiguration: _cache[1] || (_cache[1] = (returnFocusSelector, defaultTab) => emit('show-configuration', returnFocusSelector, defaultTab))
              }, null, 8, ["labels"])
            ]))
          : _createCommentVNode("", true),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (!showBothEmpty.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(Annotations, {
                annotations: _ctx.annotations,
                onShowConfiguration: _cache[2] || (_cache[2] = (returnFocusSelector, defaultTab) => emit('show-configuration', returnFocusSelector, defaultTab))
              }, null, 8, ["annotations"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1,
      __: [3,4,5]
    }, 16),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createVNode(ExtensionPanel, {
      class: "ppb-3",
      resource: _ctx.resource,
      type: _unref(ExtensionPoint).PANEL,
      location: _unref(PanelLocation).DETAIL_TOP
    }, null, 8, ["resource", "type", "location"])
  ], 64))
}
}

})